/*
  Lightweight page prefetch to improve perceived speed on internal navigation.
  - Prefetches internal links on hover/touch/focus
  - Prefetches visible internal links when they enter viewport
  - Skips sensitive routes and slow connections
*/
(function() {
  'use strict';

  if (!document || !document.head) {
    return;
  }

  var link = document.createElement('link');
  var supportsPrefetch = !!(link.relList && link.relList.supports && link.relList.supports('prefetch'));
  if (!supportsPrefetch) {
    return;
  }

  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection && (connection.saveData || /2g/i.test(connection.effectiveType || ''))) {
    return;
  }

  var MAX_PREFETCH = 16;
  var prefetched = {};
  var prefetchedCount = 0;
  var blockedPaths = [
    /^\/cart(?:\/|$)/,
    /^\/checkout(?:\/|$)/,
    /^\/account(?:\/|$)/,
    /^\/challenge(?:\/|$)/,
    /^\/search(?:\/|$)/,
    /^\/apps(?:\/|$)/,
    /^\/tools(?:\/|$)/
  ];

  function closestAnchor(node) {
    if (!node) return null;
    if (node.closest) return node.closest('a[href]');

    while (node && node !== document) {
      if (node.tagName && node.tagName.toLowerCase() === 'a' && node.getAttribute('href')) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function canUseAnchor(anchor) {
    if (!anchor || !anchor.href) return false;
    if (anchor.hasAttribute('download')) return false;
    if (anchor.target && anchor.target !== '_self') return false;
    if (anchor.getAttribute('data-no-prefetch') !== null) return false;
    if ((anchor.getAttribute('rel') || '').indexOf('no-prefetch') !== -1) return false;

    return true;
  }

  function parseUrl(href) {
    try {
      return new URL(href, window.location.href);
    } catch (e) {
      return null;
    }
  }

  function isBlockedPath(pathname) {
    var i;
    for (i = 0; i < blockedPaths.length; i++) {
      if (blockedPaths[i].test(pathname)) {
        return true;
      }
    }
    return false;
  }

  function canPrefetch(url) {
    if (!url) return false;
    if (url.origin !== window.location.origin) return false;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    if (isBlockedPath(url.pathname)) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return false;
    if (url.search && /(?:^|[?&])(variant|section_id|view)=/i.test(url.search)) return false;
    return true;
  }

  function prefetch(url) {
    var href = url.href;
    if (!href || prefetched[href] || prefetchedCount >= MAX_PREFETCH) {
      return;
    }

    prefetched[href] = true;
    prefetchedCount += 1;

    var prefetchTag = document.createElement('link');
    prefetchTag.rel = 'prefetch';
    prefetchTag.as = 'document';
    prefetchTag.href = href;
    document.head.appendChild(prefetchTag);
  }

  function prefetchAnchor(anchor) {
    if (!canUseAnchor(anchor)) return;
    var url = parseUrl(anchor.href);
    if (!canPrefetch(url)) return;
    prefetch(url);
  }

  function bindIntentPrefetch() {
    document.addEventListener(
      'mouseover',
      function(event) {
        var anchor = closestAnchor(event.target);
        if (anchor) {
          prefetchAnchor(anchor);
        }
      },
      false
    );

    document.addEventListener(
      'touchstart',
      function(event) {
        var anchor = closestAnchor(event.target);
        if (anchor) {
          prefetchAnchor(anchor);
        }
      },
      false
    );

    document.addEventListener(
      'focusin',
      function(event) {
        var anchor = closestAnchor(event.target);
        if (anchor) {
          prefetchAnchor(anchor);
        }
      },
      false
    );
  }

  function bindViewportPrefetch() {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          prefetchAnchor(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '300px 0px'
      }
    );

    var links = document.querySelectorAll('a[href]');
    var i;
    for (i = 0; i < links.length; i++) {
      if (prefetchedCount >= MAX_PREFETCH) {
        break;
      }
      if (canUseAnchor(links[i])) {
        observer.observe(links[i]);
      }
    }
  }

  function init() {
    bindIntentPrefetch();
    bindViewportPrefetch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
